export default __webpack_public_path__ + "static/media/plus-icon.ef3b60da.svg";